import './Login.scss';

import React, { FC, useContext, useEffect } from 'react';
import { AuthorizationParams, useAuth0 } from '@auth0/auth0-react';
import { LogLevel } from 'models/LogLevel';
import { Navigate, useSearchParams } from 'react-router-dom';

import { AppContext, NotificationType } from '../AppContext/AppContext';


interface LoginProps {
  targetUrl: string;
}

const Login: FC<LoginProps> = ({ targetUrl }) => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const { notify, sendLog } = useContext(AppContext);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return;
    }

    const email = searchParams.get("buyer_email");
    const authorizationParams: AuthorizationParams = email ? { login_hint: email } : {};

    const authenticateUser = async () => {
      await loginWithRedirect({
        appState: { targetUrl },
        authorizationParams
      });
    };

    authenticateUser().catch((e) => {
      const message = 'Could not authenticate user.';
      notify(message, NotificationType.Error);
      sendLog(message, LogLevel.error, e);
    });
  }, [isLoading, isAuthenticated, loginWithRedirect, targetUrl]);

  if (isLoading) {
    return <div className="Login">Logging in...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to={targetUrl} replace />;
  }
  return <div />;
};

export default Login;
